import React, {
    createContext,
    Dispatch,
    PropsWithChildren,
    useContext,
    useState,
} from 'react';

export interface AnimationContextProps {
    selectedCardState: string;
    optionsCardState: string;
    contactCardState: string;
    upsellCardState: string;

    setSelectedCardState: Dispatch<React.SetStateAction<string>>;
    setOptionsCardState: Dispatch<React.SetStateAction<string>>;
    setContactCardState: Dispatch<React.SetStateAction<string>>;
    setUpsellCardState: Dispatch<React.SetStateAction<string>>;
}

export const AnimationContext = createContext<AnimationContextProps>({
    selectedCardState: '',
    optionsCardState: '',
    contactCardState: '',
    upsellCardState: '',
    setSelectedCardState: () => {

    },
    setOptionsCardState: () => {

    },
    setContactCardState: () => {

    },
    setUpsellCardState: () => {

    },
});

export function AnimationContextProvider({ children }: PropsWithChildren) {
    const [selectedCardState, setSelectedCardState] = useState<string>('');
    const [optionsCardState, setOptionsCardState] = useState<string>('');
    const [contactCardState, setContactCardState] = useState<string>('');
    const [upsellCardState, setUpsellCardState] = useState<string>('');

    return (
        <AnimationContext.Provider
            value={{
                selectedCardState,
                optionsCardState,
                contactCardState,
                upsellCardState,
                setSelectedCardState,
                setOptionsCardState,
                setContactCardState,
                setUpsellCardState,
            }}
        >
            {children}
        </AnimationContext.Provider>
    );
}

export const useAnimationContext = () => {
    const context = useContext(AnimationContext);

    return context;
};
